/* Presentation only: Impulse owns suggestions, submission and dismissal. */
(() => {
  if (customElements.get('fizzy-mobile-search')) return;
  class FizzyMobileSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      if (!this.input) return;
      if (this.defaultPlaceholder === undefined) {
        this.defaultPlaceholder = this.input.getAttribute('placeholder') || '';
        this.defaultLabel = this.input.getAttribute('aria-label');
      }
      this.media = window.matchMedia('(max-width: 768px)');
      this.sync = () => {
        const inline = this.dataset.enabled === 'true' && this.media.matches;
        this.input.placeholder = inline && this.dataset.placeholder
          ? this.dataset.placeholder : this.defaultPlaceholder;
        if (inline && this.dataset.label) this.input.setAttribute('aria-label', this.dataset.label);
        else if (this.defaultLabel !== null) this.input.setAttribute('aria-label', this.defaultLabel);
        else this.input.removeAttribute('aria-label');
        if (this.wasInline && !inline) this.querySelector('predictive-search')?.close?.();
        this.wasInline = inline;
      };
      this.media.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      if (this.media && this.sync) this.media.removeEventListener('change', this.sync);
    }
  }
  customElements.define('fizzy-mobile-search', FizzyMobileSearch);
})();
